import { render, staticRenderFns } from "./AddMarketPic.vue?vue&type=template&id=596279fe"
import script from "./AddMarketPic.vue?vue&type=script&lang=js"
export * from "./AddMarketPic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports